// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_rq-0";